import styled from 'styled-components';

export const ModalWrapper = styled.div`
  background: #ffffff;
  border-radius: 3px;
  padding: 20px;
  z-index: 999;
  width: 375px;
  max-width: 100%;
`;
